<template>
  <div >
    <Navbar/>
    <v-container id="policy" style="background: white; font-size: 16px; padding: 16px !important;font-family: 'CS ChatThaiUI' !important; text-align: center;" mt-5>
     <!--  <br>
     <h2 style="text-align: center;">Mobile</h2>
     <br>
     -->
        
         <br>    
     <img style="margin-top: 0vw; height: 50vh;" src="/static/image/android_photo/banner-homepage.jpg">
<h3 style="margin-top: 20px;">สำหรับนักพัฒนา สามารถดาวน์โหลด apk onechat-uat (สำหรับ android) ได้แล้ว</h3>
   <br>    
<!-- 
       <a href="https://box.one.th/publicfile?id=7vJhQv5nTJZ7uVg9K1NXekPwFsdU9aog37byrSlzTm0.eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJmaWxlX2lkIjoiY2QyNGE3NTYxZDU3ODA1Yzk0ZGJiMmExYTlmNTZmM2IifQVJd0G2gG9FOrJKkv7E2uNapzTStUyLEA" target="_blank">
        ดาวน์โหลด onechat-uat.apk
      </a> -->


      <v-btn dark @click="openlink_newtab()" style="text-transform: none;
    background: #2562af;
    box-shadow: none;
    border-radius: 6px;">
            ดาวน์โหลด onechat-uat.apk
          </v-btn>



      <br>     <br>


    </v-container>
    <!-- <Footer/> -->
  </div>
</template>

<script>
import Navbar from '@/components/home/Navbarapi'
import Footer from '@/components/home/Footer'
export default {
  components: {
    Navbar,
    Footer
  },
  methods: {
    openlink_newtab () {
      window.open('https://box.one.th/publicfile?id=YzzNslJNmE2IchTR4XAzrpS_eJTYIy5YlqtZDEEelQU.eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJmaWxlX2lkIjoiZDhjYmVkNTU5NGE1OTFkMjg5OTdjMTIzOGNlM2E0MTIifQs7yBDbpabPLEe5CYiqkfjGQon9jWr3bo', '_blank')
    }
  },
  data: () => ({
    // items: [
    //   {src: '/static/image/ios_photo/ios_friend.png'},
    //   {src: '/static/image/ios_photo/ios_login.png'}
    // ]
  })
}
</script>

<style type="text/css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/home/download-uat.vue